import en from "./locales/en";
import sv from "./locales/sv";
import da from "./locales/da";

export default {
  sv,
  en,
  da,
};
